<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>Contact Us</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-img
          src="../../../assets/images/MimboLogo.png"
          class="logo"
        ></ion-img>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-title color="darkmimbo"
          ><div class="ion-text-wrap">
            Got any questions or requests? We are happy to help!
          </div></ion-title
        >
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-item color="lightmimbo">
          <ion-input label="Title" labelPlacement="floating" #title></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-item color="lightmimbo">
          <ion-textarea
            #message
            rows="10"
            label="Message"
            autoGrow="true"
            labelPlacement="floating"
            placeholder="Enter your message here..."
          ></ion-textarea
        ></ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="4" offsetMd="4" class="ion-text-center">
        <ion-button (click)="sendMessage(title.value,message.value)"
          >Send Message<ion-icon slot="start" name="send-outline"></ion-icon
        ></ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
